<h2 mat-dialog-title>{{title}}</h2>
<div mat-dialog-content>
  <p [innerHTML]="message"></p>
</div>
<div mat-dialog-actions align="center">
  <button class="btn btn-success" mat-button [mat-dialog-close]="true" cdkFocusInitial>OK</button>
</div>
